import { PROJECT_STATUS } from "../../../util/enums";

export const getProjectStatus = (status) => {
    switch (status) {
        case PROJECT_STATUS.NOT_STARTED: return <span className="notstarted-badge">Not Started</span>;
        case PROJECT_STATUS.PENDING: return <span className="pending-badge">Pending</span>;
        case PROJECT_STATUS.IN_PROGRESS: return <span className="inprogress-badge">In Progress</span>;
        case PROJECT_STATUS.COMPLETED: return <span className="completed-badge">Completed</span>;
        case PROJECT_STATUS.DLP: return <span className="dlp-badge">DLP</span>;
        case PROJECT_STATUS.LOST: return <span className="lost-badge">Lost</span>;
        case PROJECT_STATUS.TENDER_SUBMITTED: return <span className="submitted-badge">Submitted</span>;
        case PROJECT_STATUS.COSTED: return <span className="costed-badge">Costed</span>;
        case PROJECT_STATUS.LOI: return <span className="loi-badge">LOI</span>;
        case PROJECT_STATUS.ARCHIVED: return <span className="cancelled-badge">Archived</span>;
        case PROJECT_STATUS.CANCELLED: return <span className="cancelled-badge">Cancelled</span>;
        default: return status;
    }
}